/**
 * Query keys shared outside the hook layer.
 *
 * `memberKeys.me()` in `hooks/useUsers.ts` builds on this, so the axios interceptor can
 * invalidate the session without importing the hooks (which would be a circular import).
 */
export const CURRENT_MEMBER_QUERY_KEY = ['members', 'me'] as const;
